/**
 * field-tooltip.js
 * -------------------------------
 * Generic ⓘ-button tooltip for form-field help text. Any button matching
 * `.field-info-btn[data-tip]` gets a floating dark tooltip card on
 * hover/focus, showing the plain-text content of its data-tip attribute.
 *
 * Same visual language and show/hide timing as the dashboard's
 * .panel-info-btn / .panel-tooltip (views/pages/staff-info/dashboard.ejs),
 * but content-agnostic (single string, not a keyed structured-content
 * dictionary) so it works for arbitrary form fields site-wide.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var TRIGGER_SELECTOR = '.field-info-btn';
  var HIDE_DELAY_MS = 120;

  var tip = null;
  var activeBtn = null;
  var hideTimer = null;

  function ensureTip() {
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'field-tooltip';
      tip.setAttribute('role', 'tooltip');
      tip.hidden = true;
      document.body.appendChild(tip);
    }
    return tip;
  }

  function positionTip(btn) {
    var t = ensureTip();
    var rect = btn.getBoundingClientRect();
    var scrollY = window.scrollY || document.documentElement.scrollTop;
    var scrollX = window.scrollX || document.documentElement.scrollLeft;
    var tipW = t.offsetWidth || 240;
    var left = rect.left + scrollX;
    if (left + tipW > window.innerWidth - 12) left = window.innerWidth - tipW - 12;
    if (left < 8) left = 8;
    t.style.left = left + 'px';
    t.style.top = (rect.bottom + scrollY + 6) + 'px';
  }

  function showTip(btn) {
    var text = btn.dataset.tip;
    if (!text) return;
    clearTimeout(hideTimer);
    var t = ensureTip();
    t.textContent = text;
    t.hidden = false;
    positionTip(btn);
    activeBtn = btn;
    btn.setAttribute('aria-expanded', 'true');
  }

  function hideTip(immediate) {
    function run() {
      if (!tip) return;
      tip.hidden = true;
      if (activeBtn) {
        activeBtn.setAttribute('aria-expanded', 'false');
        activeBtn = null;
      }
    }
    if (immediate) {
      clearTimeout(hideTimer);
      run();
      return;
    }
    hideTimer = setTimeout(run, HIDE_DELAY_MS);
  }

  function closestTrigger(target) {
    return target && target.closest ? target.closest(TRIGGER_SELECTOR) : null;
  }

  document.addEventListener('mouseover', function (e) {
    var btn = closestTrigger(e.target);
    if (btn) showTip(btn);
  });

  document.addEventListener('mouseout', function (e) {
    var btn = closestTrigger(e.target);
    if (btn) hideTip();
  });

  document.addEventListener('focusin', function (e) {
    var btn = closestTrigger(e.target);
    if (btn) showTip(btn);
  });

  document.addEventListener('focusout', function (e) {
    var btn = closestTrigger(e.target);
    if (btn) hideTip();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && tip && !tip.hidden) hideTip(true);
  });

  window.addEventListener('scroll', function () {
    if (activeBtn) positionTip(activeBtn);
  }, true);
})();
